package com.qrkontaq.ui.admin

object AdminStringsFr : AdminStrings {
    override val tabDashboard = "Aperçu"
    override val tabDashboardSub = "Ce qui se passe dans votre établissement aujourd'hui"
    override val tabMenu = "Menu"
    override val tabMenuSub = "Catégories, plats, prix et stop-liste"
    override val tabStopList = "Stop-liste"
    override val tabStopListSub = "Un plat épuisé ? Un seul geste"
    override val tabTables = "Tables"
    override val tabTablesSub = "Appels de la salle et QR codes à imprimer"
    override val tabStaff = "Équipe"
    override val tabStaffSub = "Invitations et rôles des employés"
    override val tabSettings = "Réglages"
    override val tabSettingsSub = "Marque, contacts, horaires d'ouverture"
    override val tabSubscription = "Abonnement"
    override val tabSubscriptionSub = ""

    override val openSite = "Ouvrir le site"
    override val logout = "Se déconnecter"
    override val viewSite = "voir le site"
    override val roleOwner = "Propriétaire"
    override val roleManager = "Manager"
    override val roleWaiter = "Serveur"
    override val roleCook = "Cuisinier"
    override val roleBartender = "Barman"
    override val roleStaff = "Employé"

    override val interfaceLanguage = "Langue du panneau"
    override val pastDueBanner = "La période payée est terminée. Les fonctions Pro restent actives encore quelques jours."
    override val pay = "Payer"
    override val statScans = "Scans QR"
    override val periodToday = "Aujourd'hui"
    override val periodWeek = "Semaine"
    override val periodMonth = "Mois"
    override val periodYear = "Année"
    override val prevPeriod = "Période précédente"
    override val nextPeriod = "Période suivante"
    override val statVisits = "Visites"
    override val statRevenue = "Chiffre d'affaires"
    override val statRating = "Note"
    override val statDishLikes = "Likes des plats"
    override val statCookedOrders = "Commandes préparées"
    override val statCookedDishes = "Plats préparés"
    override val statDrinksMade = "Boissons préparées"
    override val statServedOrders = "Commandes prises"
    override val statServedDishes = "Articles pris"
    override val statTablesServed = "Tables servies"
    override val myDishesCooked = "Ce que vous avez préparé"
    override val myDrinksMade = "Les boissons que vous avez préparées"
    override val myDishesServed = "Ce que vous avez pris"
    override val myTablesTitle = "Tables"
    override val myTimelineTitle = "Chronologie"
    override val myWorkEmpty = "Aucune donnée pour cette période"
    override val scansByDay = "Évolution des scans"
    override fun maxBadge(value: String) = "max $value"
    override val peakHours = "Heures de pointe (scans)"
    override val scansByTable = "Scans par table"
    override val withoutTable = "sans table"
    override fun tableN(label: String) = "Table $label"
    override val topDishes = "Plats préférés des clients"
    override val soldProducts = "Produits vendus"
    override val dashEmptyTables = "Pas encore de scans"
    override val dashEmptyTablesHint = "Imprimez les QR codes des tables — les statistiques par table apparaîtront ici"
    override val dashEmptySales = "Pas encore de ventes"
    override val dashEmptySalesHint = "Dès que les clients commanderont, le chiffre d'affaires par plat apparaîtra ici"
    override val dashEmptyTop = "Pas encore de likes"
    override val dashEmptyTopHint = "Les clients peuvent aimer les plats du menu — les préférés apparaîtront ici"
    override val dashEmptyCallsHint = "Aucun appel sur cette période"
    override val dashEmptyPeakHint = "Les données apparaîtront après les premiers scans QR"

    override val tabOrders = "Commandes"
    override val tabOrdersSub = "Cuisine et salle : statuts des plats en temps réel"
    override val statusNew = "Nouveau"
    override val statusCooking = "En cuisine"
    override val statusReady = "Prêt"
    override val statusServed = "Servi"
    override val takeOrder = "Lancer la préparation"
    override val markReady = "Prêt"
    override val markServed = "Servi"
    override val newOrderTitle = "Nouvelle commande"
    override val addOrderBtn = "Ajouter une commande"
    override val addDishesHint = "Ajoutez des plats du menu"
    override val totalLabel = "Total"
    override val markPaid = "Payé"
    override val confirmPaid = "Marquer comme payée et libérer la table ?"
    override val tableFree = "Libre"
    override val noActiveOrders = "Aucune commande active"
    override val ordersColumnEmpty = "Vide"
    override fun orderTakenBy(name: String) = "Prise par $name"
    override val orderOtherWaiter = "Commande d'un autre serveur"
    override val closeMixedTableHint = "Cette table a une commande d'un autre serveur — un manager peut la fermer"
    override val waitingWaiter = "En attente du serveur"
    override val closeLabel = "Fermer"
    override fun minutesShort(min: Long) = "$min min"
    override fun agoShort(min: Long) = when {
        min < 60 -> "$min min"
        min < 1440 -> "${min / 60} h"
        else -> "${min / 1440} j"
    }
    override val orderStepBack = "Revenir en arrière"
    override val authCabinet = "L'espace de votre établissement"
    override val authRegisterSub = "Créez un compte pour vous connecter"
    override val authShopName = "Nom du restaurant"
    override val authShopNamePh = "Café « Le Cosy »"
    override val authDomain = "Domaine"
    override val authDomainPh = "lecosy"
    override val authPassword = "Mot de passe"
    override val authSignIn = "Se connecter"
    override val authCreateAccount = "Créer un compte"
    override val authCreateShop = "Créer l'établissement"
    override val authWizardSub = "Dernière étape : créez votre établissement"
    override val authNoShop = "Pas encore d'établissement ? S'inscrire"
    override val authHaveAccount = "Déjà inscrit ? Se connecter"
    override val authNoAccount = "Pas de compte ? S'inscrire"
    override val authOr = "ou"
    override val authBack = "Retour"
    override val authContinueGoogle = "Continuer avec Google"
    override val authContinueApple = "Continuer avec Apple"
    override val authLoginFailed = "Email ou mot de passe incorrect."
    override val authRegisterFailed = "Impossible de s'inscrire. Vérifiez les informations."
    override val authErrEmailInvalid = "Saisissez un email valide — par exemple you@example.com."
    override val authErrEmailTaken = "Cet email est déjà enregistré. Essayez de vous connecter."
    override val authErrDomainTaken = "Cette adresse de site est déjà prise — choisissez-en une autre."
    override val authErrDomainRules =
        "Adresse du site : 3–30 caractères, uniquement lettres latines, chiffres et tirets ; doit commencer et se terminer par une lettre ou un chiffre."
    override val authPasswordHint = "Au moins 6 caractères"
    override val authErrPasswordRules =
        "Le mot de passe est trop court : au moins 6 caractères requis."
    override val authErrInvalidCredentials = "Email ou mot de passe incorrect."
    override val authErrOauthAccount = "Ce compte se connecte via Google/Apple — utilisez ce bouton de connexion."
    override val authErrOauthEmailTaken = "Cet e-mail est déjà enregistré avec un mot de passe — connectez-vous avec votre e-mail et mot de passe."
    override val authErrDeactivated = "Ce compte est désactivé. Contactez le support."
    override val authErrDomainReserved = "Cette adresse est réservée par le système — choisissez-en une autre."
    override val authErrNameRules = "Nom de l'établissement : de 1 à 100 caractères."
    override val brandTagline = "Votre site en 1 minute — et utilisez-le aussitôt"
    override val brandFeature1 = "Menu QR en plusieurs langues"
    override val brandFeature2 = "Salle et cuisine en temps réel"
    override val brandFeature3 = "Statistiques, stop-liste et équipe"
    override val brandFeature4 = "Commandes, additions et paiement"
    override val brandFeature6 = "Offre gratuite, sans carte"
    override val inviteWelcome = "Rejoindre l'équipe"
    override val inviteAccepting = "Acceptation de l'invitation…"
    override fun inviteJoined(role: String) = "Vous avez rejoint l'équipe en tant que $role"
    override val inviteGoCabinet = "Accéder à l'espace"
    override val inviteInvalid = "L'invitation est invalide ou a expiré"
    override val inviteLoginHint = "Connectez-vous ou inscrivez-vous pour accepter l'invitation"
    override val hallCalls = "Appels de la salle"
    override val legendWaiter = "Serveur"
    override val legendBill = "Addition"
    override val asksBill = "demande l'addition"
    override val callsWaiter = "appelle un serveur"
    override val done = "Terminé"
    override val markedDone = "Marqué comme terminé"
    override val callUpdateFailed = "Impossible de mettre à jour l'appel"
    override val layoutSaveFailed = "Impossible d'enregistrer le plan des tables"
    override val bootFailed = "Impossible de joindre le serveur. Vérifiez votre connexion et réessayez."
    override val bootRetry = "Réessayer"

    override fun inStop(count: Int) = "En stop : $count"
    override fun totalDishes(count: Int) = "Total des plats : $count"
    override val searchDishPh = "Rechercher un plat…"
    override val nothingFound = "Aucun résultat"
    override val tryAnotherQuery = "Essayez une autre recherche"
    override val outOfStock = "épuisé"
    override fun backInMenu(name: String) = "« $name » est de retour au menu"
    override val putToStop = "Mis en stop-liste"
    override val updateFailed = "Impossible de mettre à jour"

    override val addTableTitle = "Ajouter une table"
    override val tableLabelPh = "Ex. 5 ou Terrasse 2"
    override val add = "Ajouter"
    override val addTableFailed = "Impossible d'ajouter la table"
    override fun tablesCount(count: Int) = "Tables ($count)"
    override val qrPdf = "QR en PDF"
    override val preparingPdf = "Préparation du PDF…"
    override fun deleteTable(label: String) = "Supprimer la table $label"
    override fun deleteTableConfirm(label: String) = "Supprimer la table $label ?"
    override val planHint = "Faites glisser les tables pour reproduire votre salle. Le plan est enregistré dans ce navigateur."
    override val noTablesTitle = "Pas encore de tables"
    override val noTablesHint = "Ajoutez des tables — nous générerons un PDF avec les QR codes à imprimer"

    override val inviteTitle = "Inviter un employé"
    override val inviteHint = "Serveur — tables et commandes. Cuisinier — commandes (tables en lecture seule). Manager — tout sauf l'abonnement."
    override val createInvite = "Créer une invitation"
    override val inviteCreated = "Invitation créée"
    override val inviteCreateFailed = "Impossible de créer l'invitation"
    override val copy = "Copier"
    override val copied = "Copié"
    override fun teamCount(count: Int) = "Équipe ($count)"
    override val removeFromTeam = "Retirer de l'équipe"
    override val removeFromTeamConfirm = "Retirer de l'équipe ?"
    override val activeInvites = "Invitations actives :"
    override fun validUntil(date: String) = "valide jusqu'au $date"
    override val cancel = "Annuler"
    override val teamMembersWord = "membres"
    override fun teamMemberSince(date: String) = "dans l'équipe depuis le $date"
    override val permWaiter = "Tables et commandes"
    override val permCook = "Commandes cuisine"
    override val permBartender = "Commandes bar"
    override val permManager = "Tout sauf l'abonnement"
    override val barCategory = "Catégorie bar (boissons)"
    override val barBadge = "Bar"

    override val currentState = "État actuel"
    override fun activeUntil(date: String) = "Actif jusqu'au $date"
    override val pastDueLong = "Paiement en retard — les fonctions Pro seront bientôt suspendues"
    override val badgeActive = "Actif"
    override val badgePastDue = "En retard"
    override val plan1Month = "1 mois"
    override val plan3Months = "3 mois"
    override val plan12Months = "12 mois"
    override val bestValueBadge = "-17% · avantageux"
    override val payMono = "Choisir"
    override val payHint = "Paiement via la page sécurisée monobank. Après le paiement, l'abonnement se renouvelle automatiquement."
    override val autoRenewLabel = "Renouvellement automatique"
    override val autoRenewHint = "Votre carte est enregistrée après le paiement et l'abonnement se renouvelle automatiquement. Désactivable à tout moment."
    override val autoRenewActive = { mask: String? ->
        "Renouvellement automatique activé" + (mask?.let { " · carte •••• $it" } ?: "")
    }
    override val autoRenewDisable = "Désactiver"
    override val planActiveTitle = "Offre activée"
    override val nextChargeOn = { date: String, amount: String -> "Prochain prélèvement le $date · $amount" }
    override val autoRenewOffNote = { date: String -> "Renouvellement automatique désactivé — l'accès reste valable jusqu'au $date" }
    override val cancelSubscription = "Annuler l'abonnement"
    override val resumeAutoRenew = "Réactiver le renouvellement automatique"
    override val subActiveOverline = "Abonnement actif"
    override val subEyebrow = "Offres"
    override val subChooseTitle = "Free ou Pro"
    override val subChooseSub = "Menu, commandes et tables — gratuits pour toujours. Pro débloque les services clients et l'équipe."
    override val subFeaturesCap = "Inclus dans Pro"
    override val subFeatures = listOf(
        "Programme de fidélité avec cashback",
        "Bouton d'appel du serveur",
        "Addition de la table pour les clients",
        "Menu en plusieurs langues",
        "Sections « Populaire » et « Le chef recommande »",
        "Équipe et invitations du personnel",
    )
    override val subCtaSubscribe = "Passer à Pro"
    override val trustCancel = "Annulable à tout moment"
    override val trustSecure = "Paiement sécurisé"

    override val planFree = "Free"
    override val planPro = "Pro"
    override val planFreeSub = "menu sans limites"
    override val planCurrent = "Votre offre"
    override val planRecommended = "Recommandée"
    override val perMonth = "par mois"
    override val proLockTitle = "Disponible avec Pro"
    override val proLockTeamBody = "Invitez serveurs, cuisiniers et managers avec l'offre Pro. Les membres actuels de l'équipe restent."
    override val proUpgradeCta = "Passer à Pro"
    override val proSectionHint = "Disponible avec l'offre Pro — activez-la dans l'onglet « Abonnement »."
    override val proLangHint = "Avec Free, une seule langue de menu est active — changez-la à tout moment. Pro débloque toutes les langues."
    override val paymentHistory = "Historique des paiements"

    override val newCategory = "Nouvelle catégorie"
    override val addCategory = "Ajouter une catégorie"
    override val hiddenBadge = "masqué"
    override val showLabel = "Afficher"
    override val hideLabel = "Masquer"
    override val moreActions = "Plus d'actions"
    override val moveUp = "Monter"
    override val moveDown = "Descendre"
    override val deleteCategory = "Supprimer la catégorie"
    override fun deleteCategoryConfirm(name: String) = "Supprimer la catégorie « $name » avec ses plats ?"
    override val addDishPlus = "＋ Ajouter un plat"
    override val copySuffix = " (copie)"
    override val duplicate = "Dupliquer"
    override val dishDuplicated = "Plat dupliqué"
    override val duplicateFailed = "Impossible de dupliquer"
    override val edit = "Modifier"
    override val delete = "Supprimer"
    override fun deleteDishConfirm(name: String) = "Supprimer « $name » ?"
    override val dishDeleted = "Plat supprimé"
    override val deleteFailed = "Impossible de supprimer"
    override val dangerZoneTitle = "Zone de danger"
    override val dangerZoneHint =
        "La suppression de l'établissement est irréversible : le menu, les photos, les tables, les commandes, l'équipe, la fidélité et l'adresse du site disparaîtront."
    override val deleteVenueButton = "Supprimer l'établissement"
    override val deleteVenueModalTitle = "Supprimer cet établissement ?"
    override val deleteVenueModalBody =
        "Cette action est irréversible. Seront définitivement supprimés : le menu et les photos, les tables et les QR codes, " +
            "les commandes et les statistiques, l'équipe et les invitations, le programme de fidélité et l'adresse du site."
    override fun deleteVenueConfirmLabel(name: String) = "Pour confirmer, saisissez le nom « $name »"
    override val deleteVenueConfirmPlaceholder = "Nom de l'établissement"
    override val deleteVenueConfirmCta = "Supprimer définitivement"
    override val deleteVenueSuccess = "Établissement supprimé"
    override val stopBadge = "stop"
    override val descriptionLabel = "Description"
    override val descriptionPh = "Ex. : Tomates, mozzarella, basilic frais"
    override val priceLabel = "Prix"
    override val weightLabel = "Poids/volume"
    override val weightPh = "320 g"
    override val kcalLabel = "Kcal"
    override val tagsLabel = "Tags"
    override val allergensLabel = "Allergènes"
    override val tagVegan = "Végan"
    override val tagSpicy = "Épicé"
    override val tagNew = "Nouveau"
    override val allergenGluten = "Gluten"
    override val allergenLactose = "Lactose"
    override val allergenNuts = "Fruits à coque"
    override val allergenEggs = "Œufs"
    override val allergenFish = "Poisson"
    override val allergenSoy = "Soja"
    override val chefRecommends = "Le chef recommande"
    override val uploadingEllipsis = "Téléversement…"
    override val addPhoto = "Ajouter une photo"
    override val replacePhoto = "Remplacer la photo"
    override val photoUploadFailed = "Impossible de téléverser la photo"
    override val addDish = "Ajouter un plat"
    override val save = "Enregistrer"
    override val dishAdded = "Plat ajouté"
    override val savedToast = "Enregistré"
    override val saveFailed = "Impossible d'enregistrer"
    override val menuStatCategories = "catégories"
    override val menuStatDishes = "plats"
    override val menuStatFeatured = "vedettes"
    override val menuEmptyTitle = "Votre menu est vide"
    override val menuEmptyHint = "Créez votre première catégorie — puis ajoutez des plats."
    override val categoryLabel = "Catégorie"
    override val editCategory = "Modifier la catégorie"
    override val editDish = "Modifier le plat"
    override val noCategory = "Sans catégorie"

    override val sitePreviewTitle = "À quoi ressemblera le site"
    override val sitePreviewHint = "L'aperçu se met à jour instantanément — enregistrez pour l'appliquer sur le site."
    override val restaurantNamePh = "Nom de l'établissement"
    override val brandTitle = "Marque"
    override val logoLabel = "Logo"
    override val coverLabel = "Couverture"
    override val nameLabel = "Nom"
    override val shortDescription = "Brève description"
    override val accentHint = "Couleur d'accent — boutons, prix et surbrillances sur le site de votre établissement"
    override val customColorLabel = "Ou une couleur personnalisée"
    override val contactsTitle = "Contacts"
    override val addressLabel = "Adresse"
    override val mapPickHint = "Déplacez la carte pour que le repère pointe sur votre établissement"
    override val mapFindByAddress = "Trouver par adresse"
    override val mapUseLocation = "Ma position"
    override val phoneLabel = "Téléphone"
    override val socialsHint = "Réseaux sociaux — affichés aux clients dans la section « À propos » du site"
    override val workingHoursTitle = "Horaires d'ouverture"
    override val workingHoursHint = "Vide = fermé. Format 09:00 / 22:00, les horaires de nuit sont aussi pris en charge (18:00–02:00)."
    override val dayMon = "Lun"
    override val dayTue = "Mar"
    override val dayWed = "Mer"
    override val dayThu = "Jeu"
    override val dayFri = "Ven"
    override val daySat = "Sam"
    override val daySun = "Dim"
    override val dayOff = "fermé"
    override val siteThemeTitle = "Thème du site"
    override val siteThemeHint = "L'apparence du menu pour le client : clair, sombre ou automatique selon les réglages du téléphone."
    override val themeAuto = "Auto (selon le client)"
    override val themeLight = "Clair"
    override val themeDark = "Sombre"
    override val menuLookTitle = "Apparence du menu"
    override val categoryPhotosTitle = "Photos dans les catégories"
    override val categoryPhotosHint = "La puce de catégorie affiche la photo du premier plat ; sans photo — texte seul"
    override val featureFirstTitle = "Premier plat en grande carte"
    override val featureFirstHint = "Le premier plat de la catégorie a une photo pleine largeur ; désactivé — comme les autres"
    override val showPopularTitle = "Section « Populaire »"
    override val showPopularHint = "Afficher une sélection de plats populaires en haut du menu"
    override val showChefTitle = "Section « Le chef recommande »"
    override val showChefHint = "Afficher une sélection de plats recommandés par le chef"
    override val showFiltersTitle = "Bouton de filtres"
    override val showFiltersHint = "Afficher le bouton de filtres à côté des catégories du menu"
    override val menuLanguagesTitle = "Langues du menu"
    override val menuLanguagesHint = "Le client pourra changer de langue sur le site. Remplissez les noms et descriptions dans les langues choisies."
    override val saveChanges = "Enregistrer les modifications"
    override val savedCheck = "Enregistré ✓"
    override val savedSiteUpdated = "Enregistré — le site est à jour"
    override val saveFailedCheckColor = "Impossible d'enregistrer (vérifiez la couleur #RRGGBB)"
    override val upload = "Téléverser"
    override val replace = "Remplacer"

    override val currencyTitle = "Devise"
    override val currencyHint = "Devise des prix du menu et des bonus des clients."
    override val guestServicesTitle = "Services à table"
    override val guestServicesHint = "Ce que le client voit sur la page de la table après avoir scanné le QR"
    override val guestCheckTitle = "Montrer l'addition au client"
    override val guestCheckHint = "Le client voit son addition en temps réel : articles, quantités et total"
    override val waiterCallTitle = "Appel du serveur"
    override val waiterCallHint = "Le client peut appeler un serveur ou demander l'addition"
    override val loyaltyTitle = "Programme de fidélité"
    override val loyaltyEnableTitle = "Cashback pour les clients"
    override val loyaltyEnableHint = "Le client cumule des bonus sur chaque addition et les utilise au moment de payer"
    override val loyaltyRateLabel = "Pourcentage de cashback sur l'addition (1–50)"
    override val loyaltyRateHint = "Ce pourcentage du montant de l'addition revient au client en bonus"
    override val loyaltyGuestTitle = "Bonus du client"
    override val loyaltyCandidatesTitle = "Ont récemment scanné cette table"
    override val loyaltyCodePh = "Code à 6 chiffres"
    override val loyaltyScanQr = "Scanner le QR"
    override val loyaltyFindGuest = "Trouver le client"
    override val loyaltyCodeNotFound = "Code introuvable"
    override val loyaltyCodeExpired = "Code expiré — demandez au client d'en montrer un nouveau"
    override val loyaltyCheckFailed = "Impossible de vérifier le code"
    override val loyaltyBalanceLabel = "Solde"
    override val loyaltyRedeemLabel = "Utiliser les bonus"
    override val loyaltyEarnedLabel = "Cumulés"
    override val loyaltyRedeemedLabel = "Utilisés"
    override val loyaltyNewBalanceLabel = "Nouveau solde"
    override val loyaltyClear = "Effacer"
    override val loyaltyCameraFailed = "Caméra indisponible — saisissez le code manuellement"
    override val loyaltyGuestAtTable = "Client à table"
    override val loyaltyNewGuest = "Nouveau client"
    override val loyaltyVisitsSuffix = "visites"
    override val loyaltyCallingWaiter = "Appelle un serveur"
    override val loyaltyCallingBill = "Demande l'addition"
}
